import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./Main.module.css";

import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Spin,
} from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkEmpty,
  getAboutLot,
  getCheckHeveGetNew,
  getCurrentDateUtilYYYY,
  getDateUtilYYYYBydate,
  getLotResults,
  getOrders,
  getOrdersV2,
  getToken,
  isAdmin,
  newDateUtil,
  reflectorLotTypes_2_version2,
  reflectorLots_2_version3,
} from "../service/util.service";
import { useNavigate } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import LotTable from "../lotTable/LotTable";
import { SearchOutlined } from "@ant-design/icons";
import LoadingCenter from "./LoadingCenter";
const { RangePicker } = DatePicker;

function Summary(props) {
  return (
    <>
      <MenuLett />
      <div className={styles.boxMain}>
        <MenuTop />
        <Content />
      </div>
    </>
  );
}

function Content(props) {
  const appContext = useContext(AppContext);
  const [lots, setLots] = useState([]);
  const [orders, setOrders] = useState([]);
  const [lotResualts, setLotResualts] = useState([]);
  const [lotTypes, setLotTypes] = useState([]);
  const [selectMonth, setSelectMonth] = useState("");
  const [selectDateFrom, setSelectDateFrom] = useState("");
  const [selectDateTo, setSelectDateTo] = useState("");
  const [searchType, setSearchType] = useState("today");
  const [loading, setLoading] = useState(false);
  const [isTop5, setIsTop5] = useState("Y");

  const [isAdminMain, setIsAdminMain] = useState(false);
  const loaderData = async () => {
    // let havegetnew = await getCheckHeveGetNew();
    let havegetnew = false;
    let aboutLot = null;
    if (!checkEmpty(localStorage.getItem("aboutLot")) && havegetnew == false) {
      aboutLot = JSON.parse(localStorage.getItem("aboutLot"));
    } else {
      try {
        aboutLot = await getAboutLot();
        localStorage.setItem("aboutLot", JSON.stringify(aboutLot));
        console.log("aboutLot", aboutLot);
      } catch (e) {}
    }

    // let datefrom = getCurrentDateUtilYYYY();
    // let dateto = getCurrentDateUtilYYYY();
    var curr = newDateUtil();
    curr.setDate(curr.getDate() + 1);
    let datefrom = getCurrentDateUtilYYYY();
    let dateto = getDateUtilYYYYBydate(curr);
    setLoading(true);
    // try {
    //   let datas = await getLotResults(datefrom, dateto);
    //   setLotResualts(datas);
    // } catch (e) {}

    // let ordersRes = [];
    try {
      console.log("appContext.acUsername", appContext.acUsername);
      let data = await getOrdersV2(
        datefrom,
        dateto,
        appContext.acUsername,
        isTop5
      );
      setLotResualts(data.lotResualts);
      setOrders(data.orders);
    } catch (e) {}
    // setLotTypes(
    //   reflectorLotTypes_2_version2(aboutLot.lotTypes, aboutLot.lots, ordersRes)
    // ); //(aboutLot.lotTypes);
    setLots(Object.assign([], reflectorLots_2_version3(aboutLot.lots)));
    setLoading(false);
  };

  useEffect(() => {
    console.log("useEffect");
    loaderData();
    if (!checkEmpty(getToken())) {
      if (isAdmin()) {
        setIsAdminMain(true);
      } else {
        setIsAdminMain(false);
      }
    }
  }, []);

  const searchAction = async () => {
    console.log("searchType", searchType);
    console.log("selectDateFrom", selectDateFrom);
    console.log("selectDateTo", selectDateTo);
    let datefrom = getCurrentDateUtilYYYY();
    let dateto = getCurrentDateUtilYYYY();
    if (searchType == "today") {
      var curr = newDateUtil();
      curr.setDate(curr.getDate() + 1);
      datefrom = getCurrentDateUtilYYYY();
      dateto = getDateUtilYYYYBydate(curr);
    } else if (searchType == "yesterday") {
      var date = newDateUtil();
      date.setDate(date.getDate() - 1);
      let dateStr = getDateUtilYYYYBydate(date);
      datefrom = dateStr;
      dateto = dateStr;
    } else if (searchType == "this_week") {
      var curr = newDateUtil(); // get current date
      var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
      var last = first + 6; // last day is the first day + 6
      let firstD = newDateUtil(curr.setDate(first));
      firstD.setDate(firstD.getDate() + 1);
      let lastD = newDateUtil(curr.setDate(last));
      lastD.setDate(lastD.getDate() + 1);
      let dateStrF = getDateUtilYYYYBydate(firstD);
      let dateStrT = getDateUtilYYYYBydate(lastD);
      datefrom = dateStrF;
      dateto = dateStrT;
    } else if (searchType == "old_week") {
      var curr = newDateUtil(); // get current date
      var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
      var last = first + 6; // last day is the first day + 6
      let firstD = newDateUtil(curr.setDate(first));
      firstD.setDate(firstD.getDate() + 1 - 7);
      let lastD = newDateUtil(curr.setDate(last));
      lastD.setDate(lastD.getDate() + 1 - 7);
      let dateStrF = getDateUtilYYYYBydate(firstD);
      let dateStrT = getDateUtilYYYYBydate(lastD);
      datefrom = dateStrF;
      dateto = dateStrT;
    } else if (searchType == "month") {
      var month = selectMonth - 1;
      var firstD = new Date(newDateUtil().getFullYear(), month, 1);
      var lastD = new Date(newDateUtil().getFullYear(), month + 1, 0);
      let dateStrF = getDateUtilYYYYBydate(firstD);
      let dateStrT = getDateUtilYYYYBydate(lastD);
      datefrom = dateStrF;
      dateto = dateStrT;
    } else if (searchType == "date_from_to") {
      datefrom = selectDateFrom;
      dateto = selectDateTo;
    }

    // try {
    //   let datas = await getLotResults(datefrom, dateto);
    //   setLotResualts(datas);
    // } catch (e) {}

    try {
      setLoading(true);
      let data = await getOrdersV2(
        datefrom,
        dateto,
        appContext.acUsername,
        isTop5
      );
      setLotResualts(Object.assign([], data.lotResualts));
      setOrders(Object.assign([], data.orders));
      // setLotTypes(
      //   Object.assign(
      //     [],
      //     reflectorLotTypes_2_version2(lotTypes, lots, ordersRes)
      //   )
      // );
      setLots(Object.assign([], reflectorLots_2_version3(lots)));
      setLoading(false);
    } catch (e) {}
  };

  return (
    <>
      <div className={styles.box100}>
        {isAdminMain && (
          <div style={{ padding: "10px" }}>
            กำลังดูของ : {appContext.acUsername}
          </div>
        )}

        <div className={styles.boxSearch}>
          <div
            style={{ width: "80px" }}
            className={isTop5 == "Y" ? styles.searchTypeAc : styles.searchType}
            onClick={() => {
              let use = isTop5;
              if (use == "N") {
                use = "Y";
              } else if (use == "Y") {
                use = "N";
              }
              setIsTop5(use);
            }}
          >
            ล่าสุด 5 หวย
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                searchType == "today" ? styles.searchTypeAc : styles.searchType
              }
              onClick={() => {
                setSearchType("today");
              }}
            >
              วันนี้
            </div>
            <div
              className={
                searchType == "yesterday"
                  ? styles.searchTypeAc
                  : styles.searchType
              }
              onClick={() => {
                setSearchType("yesterday");
              }}
            >
              เมื่อวาน
            </div>
            <div
              className={
                searchType == "this_week"
                  ? styles.searchTypeAc
                  : styles.searchType
              }
              onClick={() => {
                setSearchType("this_week");
              }}
            >
              สัปดาห์นี้
            </div>
            <div
              className={
                searchType == "old_week"
                  ? styles.searchTypeAc
                  : styles.searchType
              }
              onClick={() => {
                setSearchType("old_week");
              }}
            >
              สัปดาห์ที่แล้ว
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                searchType == "month" ? styles.searchTypeAc : styles.searchType
              }
              onClick={() => {
                setSearchType("month");
              }}
            >
              เดือน
            </div>
            <div className={styles.selectMont}>
              {" "}
              <Select
                // showSearch
                style={{ width: 200 }}
                placeholder="เลือกเดือน"
                optionFilterProp="children"
                // filterOption={(input, option) =>
                //   (option?.label ?? "").includes(input)
                // }
                // filterSort={(optionA, optionB) =>
                //   (optionA?.label ?? "")
                //     .toLowerCase()
                //     .localeCompare((optionB?.label ?? "").toLowerCase())
                // }
                onChange={(v) => {
                  setSelectMonth(v);
                }}
                options={[
                  {
                    value: "1",
                    label: "มกราคม",
                  },
                  {
                    value: "2",
                    label: "กุมภาพันธ์",
                  },
                  {
                    value: "3",
                    label: "มีนาคม ",
                  },
                  {
                    value: "4",
                    label: "เมษายน",
                  },
                  {
                    value: "5",
                    label: "พฤษภาคม",
                  },
                  {
                    value: "6",
                    label: "มิถุนายน",
                  },
                  {
                    value: "7",
                    label: "กรกฎาคม",
                  },
                  {
                    value: "8",
                    label: "สิงหาคม",
                  },
                  {
                    value: "9",
                    label: "กันยายน",
                  },
                  {
                    value: "10",
                    label: "ตุลาคม",
                  },
                  {
                    value: "11",
                    label: "พฤศจิกายน",
                  },
                  {
                    value: "12",
                    label: "ธันวาคม",
                  },
                ]}
              />
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                searchType == "date_from_to"
                  ? styles.searchTypeAc
                  : styles.searchType
              }
              onClick={() => {
                setSearchType("date_from_to");
              }}
            >
              ตั้งแต่วันที่
            </div>
            <div className={styles.selectDateFomTo}>
              <RangePicker
                onChange={(dates, dateStrings) => {
                  console.log("dateStrings", dateStrings);
                  if (!checkEmpty(dateStrings[0])) {
                    // let dateF = getDateUtilYYYYBydate(dateStrings[0]);
                    // console.log(dateF);
                    setSelectDateFrom(dateStrings[0]);
                  }
                  if (!checkEmpty(dateStrings[1])) {
                    // let dateT = getDateUtilYYYYBydate(dateStrings[1]);
                    setSelectDateTo(dateStrings[1]);
                  }
                }}
              />
            </div>
          </div>
          <div>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => {
                searchAction();
              }}
            >
              ค้นหา
            </Button>
          </div>
        </div>
        <div>
          {loading ? (
            <LoadingCenter />
          ) : (
            <>
              <div>
                {/* <div className={styles.headerType}>{type.lot_type}</div> */}
                <div className={styles.boxLotMain}>
                  {lots
                    // .filter((lot) => lot.lot_type == type.lot_type)
                    .map((lot) => {
                      let ordersUse = [];
                      for (let a = 0; a < orders.length; a++) {
                        if (orders[a].lot_id == lot.lot_id) {
                          ordersUse.push(orders[a]);
                        }
                      }
                      if (ordersUse.length > 0)
                        return (
                          // <div className={styles.boxLotItem}>{lot.lot_name}</div>
                          <LotTable
                            lot={lot}
                            orders={orders}
                            // type={type}
                            lotResualts={lotResualts}
                          ></LotTable>
                        );
                    })}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
export default Summary;
